import { useSEO } from "../lib/seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { BUSINESS } from "../lib/constants";

const SECTIONS = [
  {
    h: "What we collect",
    p: "When you contact Kay's Carpet Cleaning or submit an enquiry, we collect the details you provide — such as your name, phone number, email address, suburb and information about the cleaning job. If you send photos of the areas to be cleaned, those are included too.",
  },
  {
    h: "How we use it",
    p: "Your information is used for one purpose: to understand your cleaning requirements, provide an estimate, arrange and complete your booking, and communicate with you about the job. Nothing more.",
  },
  {
    h: "What we don't do",
    p: "We do not sell, rent or share your personal information with third parties for marketing. We do not add you to mailing lists you didn't ask for.",
  },
  {
    h: "Storage & security",
    p: "Enquiry details are kept only as long as needed to manage your job and our normal business records. Reasonable steps are taken to keep your information secure.",
  },
  {
    h: "Your choices",
    p: "You can ask us at any time what information we hold about you, or ask for it to be corrected or deleted, by contacting us using the details below.",
  },
];

const PrivacyPage = () => {
  useSEO(
    "Privacy Policy | Kay's Carpet Cleaning Gold Coast",
    "How Kay's Carpet Cleaning collects, uses and protects your personal information when you request an estimate or book a cleaning service on the Gold Coast."
  );

  return (
    <div data-testid="privacy-page">
      <PageHero
        overline="Privacy Policy"
        title="Your Privacy,"
        titleItalic="Respected"
        text="A plain-English summary of how Kay's Carpet Cleaning handles your information. Last updated: 2026."
        testId="privacy-hero"
      />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32">
        {SECTIONS.map((s) => (
          <Reveal key={s.h} className="mb-10">
            <h2 className="font-display font-medium text-2xl tracking-tight text-brand-ink">{s.h}</h2>
            <p className="mt-3 text-base text-brand-muted leading-relaxed">{s.p}</p>
          </Reveal>
        ))}
        <Reveal>
          <div className="bg-brand-mist/50 border border-brand-line/60 rounded-2xl px-7 py-6">
            <h2 className="font-display font-medium text-xl tracking-tight text-brand-ink">Contact us about privacy</h2>
            <p className="mt-3 text-base text-brand-muted leading-relaxed">
              Kay's Carpet Cleaning — Gold Coast, Queensland. Phone{" "}
              <a href={BUSINESS.phoneHref} className="text-brand font-semibold underline underline-offset-2" data-testid="privacy-phone-link">{BUSINESS.phoneDisplay}</a>{" "}
              or email{" "}
              <a href={BUSINESS.emailHref} className="text-brand font-semibold underline underline-offset-2" data-testid="privacy-email-link">{BUSINESS.email}</a>.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default PrivacyPage;
